import script from "./CallToAction.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallToAction.vue?vue&type=script&setup=true&lang=ts"

import "./CallToAction.vue?vue&type=style&index=0&id=0f948a8a&lang=scss"

const __exports__ = script;

export default __exports__